import React from 'react';

const Footer = () => {
  return (
    <footer className="relative bg-[#0A0F14] text-gray-300 mt-16 overflow-hidden">
      {/* top accent strip */}
      <div className="h-1 w-full bg-gradient-to-r from-brand-300 via-brand-500 to-brand-800" aria-hidden="true"></div>

      {/* subtle grid texture */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(0,148,217,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(0,148,217,0.6) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
        aria-hidden="true"
      ></div>

      <div className="relative container mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr_1fr] gap-10 md:gap-16">
          {/* Brand column */}
          <div>
            <a href="/" className="inline-flex items-center gap-3 mb-5 group" aria-label="RALMAQ">
              <img
                src="/ralmaq-mark.png?v=3"
                alt=""
                aria-hidden="true"
                className="h-11 w-auto shrink-0 drop-shadow-[0_0_12px_rgba(0,148,217,0.35)]"
              />
              <span className="font-display text-4xl font-extrabold text-white tracking-[0.02em] leading-none">
                RALMAQ
              </span>
            </a>
            <p className="text-sm leading-relaxed text-gray-400 max-w-md">
              Especialistas em importação de máquinas e equipamentos para a indústria metalúrgica —
              oferecendo soluções completas e seguras para o mercado brasileiro.
            </p>
            <a
              href="/about"
              className="mt-5 inline-flex items-center gap-2 text-sm font-semibold tracking-wide uppercase text-brand-300 hover:text-brand-200 transition-colors"
            >
              Saiba mais sobre nós
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-brand-300 mb-5">
              Navegação
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition-colors">
                  Produtos
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-300 hover:text-white transition-colors">
                  Quem Somos
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-brand-300 mb-5">
              Contato
            </h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-md bg-brand-500/15 text-brand-300 flex items-center justify-center flex-shrink-0">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </span>
                <a href="tel:+5551981738538" className="hover:text-white transition-colors">
                  (51) 98173-8538
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* divider */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-gray-500 tracking-wide">
            © {new Date().getFullYear()} RALMAQ. Todos os direitos reservados.
          </p>
          <p className="text-[11px] uppercase tracking-[0.25em] text-gray-600">
            Máquinas & Equipamentos Industriais
          </p>
          <p className="text-[11px] text-gray-600">
            Feito por{' '}
            <a
              href="https://www.resolvaaioficial.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-400 transition-colors"
            >
              Resolva Aí
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
